function ListFourImages({ image1, image2, image3, image4, className }: any) {
  return (
    <div className={`flex flex-row items-center justify-center ${className}`}>
      <img
        alt=""
        fetchPriority="high"
        decoding="async"
        data-nimg="1"
        className="w-[130px] max-w-none rounded-lg"
        style={{ color: "transparent" }}
        src={image1}
      ></img>
      <img
        alt=""
        fetchPriority="high"
        decoding="async"
        data-nimg="1"
        className="ml-6 w-[130px] max-w-none rounded-lg"
        style={{ color: "transparent" }}
        src={image2}
      ></img>
      <img
        alt=""
        fetchPriority="high"
        decoding="async"
        data-nimg="1"
        className="ml-6 w-[130px] max-w-none rounded-lg"
        style={{ color: "transparent" }}
        src={image3}
      ></img>
      <img
        alt=""
        fetchPriority="high"
        decoding="async"
        data-nimg="1"
        className="ml-6 w-[130px] max-w-none rounded-lg"
        style={{ color: "transparent" }}
        src={image4}
      ></img>
    </div>
  );
}

export default ListFourImages;
